export const jobOpenings = [
  {
    id: 1,
    title: 'Senior React Developer',
    department: 'Engineering',
    location: 'Mumbai',
    type: 'Full-time',
    experience: '4-8 years',
    salary: '₹18-35 LPA',
    description: 'We are looking for a Senior React Developer to build enterprise-grade web applications. You will work on large-scale client projects, mentor junior developers, and contribute to our internal component library.',
    requirements: [
      '4+ years of React/TypeScript experience',
      'Strong understanding of state management (Redux/Zustand)',
      'Experience with Next.js and SSR/ISR patterns',
      'Knowledge of GraphQL and REST APIs',
      'Familiarity with TailwindCSS and component-driven design',
      'Experience leading small teams',
    ],
    niceToHave: ['Open-source contributions', 'Experience with monorepos', 'Knowledge of testing frameworks'],
  },
  {
    id: 2,
    title: 'AI/ML Engineer',
    department: 'AI & Automation',
    location: 'Bangalore',
    type: 'Full-time',
    experience: '3-6 years',
    salary: '₹20-45 LPA',
    description: 'Join our AI division to build production machine learning systems. You will work on NLP models, recommendation engines, and predictive analytics for enterprise clients across healthcare, finance, and retail.',
    requirements: [
      '3+ years in ML/AI engineering',
      'Strong Python skills (PyTorch/TensorFlow)',
      'Experience deploying models to production',
      'Knowledge of NLP and computer vision',
      'Familiarity with MLOps tools (MLflow, Kubeflow)',
      'Experience with cloud ML services (AWS SageMaker, GCP Vertex AI)',
    ],
    niceToHave: ['Published research papers', 'Kaggle competition experience', 'Experience with LLMs and RAG'],
  },
  {
    id: 3,
    title: 'DevOps Engineer',
    department: 'Infrastructure',
    location: 'Mumbai / Remote',
    type: 'Full-time',
    experience: '5-10 years',
    salary: '₹15-32 LPA',
    description: 'Help us build and maintain infrastructure for 200+ client projects. You will own CI/CD pipelines, Kubernetes clusters, and cloud infrastructure across AWS, GCP, and Azure.',
    requirements: [
      '5+ years in DevOps/SRE roles',
      'Deep Kubernetes and Docker experience',
      'AWS/GCP/Azure certification preferred',
      'Terraform and Infrastructure-as-Code expertise',
      'Monitoring and observability (Prometheus, Grafana)',
      'Security-first mindset',
    ],
    niceToHave: ['Service mesh experience', 'Multi-cloud architecture', 'Database administration'],
  },
  {
    id: 4,
    title: 'Product Designer (UX/UI)',
    department: 'Design',
    location: 'Mumbai',
    type: 'Full-time',
    experience: '3-7 years',
    salary: '₹12-25 LPA',
    description: 'Design beautiful, intuitive interfaces for enterprise applications. You will create design systems, conduct user research, and collaborate closely with engineering teams.',
    requirements: [
      '3+ years of product design experience',
      'Expert-level Figma skills',
      'Experience building design systems',
      'Strong UX research and usability testing',
      'Portfolio demonstrating complex enterprise interfaces',
      'Understanding of accessibility standards',
    ],
    niceToHave: ['Motion design skills', 'Basic HTML/CSS knowledge', 'Experience with design tokens'],
  },
  {
    id: 5,
    title: 'Business Development Manager',
    department: 'Sales',
    location: 'Mumbai / Dubai',
    type: 'Full-time',
    experience: '6-12 years',
    salary: '₹15-30 LPA + Incentives',
    description: 'Drive enterprise sales across India and Middle East markets. You will manage relationships with Fortune 500 prospects, lead proposal development, and close 7-figure deals.',
    requirements: [
      '6+ years in B2B tech/IT sales',
      'Proven track record of closing ₹1Cr+ deals',
      'Strong network in enterprise/Gov sector',
      'Excellent proposal writing and presentation',
      'Understanding of software development lifecycle',
      'MBA preferred',
    ],
    niceToHave: ['International sales experience', 'Technical background', 'Regional language skills'],
  },
  {
    id: 6,
    title: 'Digital Marketing Specialist',
    department: 'Marketing',
    location: 'Mumbai',
    type: 'Full-time',
    experience: '2-5 years',
    salary: '₹8-18 LPA',
    description: 'Lead our digital marketing efforts including SEO, content strategy, paid campaigns, and social media. You will work on both our internal brand and client marketing projects.',
    requirements: [
      '2+ years in digital marketing',
      'Google Ads and Meta Ads certification',
      'SEO and content strategy experience',
      'Analytics and data-driven decision making',
      'Excellent written communication',
      'Experience with marketing automation tools',
    ],
    niceToHave: ['B2B marketing experience', 'Video content production', 'Google Analytics certification'],
  },
];

export const departments = [
  { name: 'Engineering', count: 80, icon: 'ri-code-box-line' },
  { name: 'AI & Automation', count: 25, icon: 'ri-brain-line' },
  { name: 'Design', count: 15, icon: 'ri-palette-line' },
  { name: 'Sales & Marketing', count: 30, icon: 'ri-line-chart-line' },
  { name: 'Infrastructure', count: 20, icon: 'ri-cloud-line' },
  { name: 'Product', count: 12, icon: 'ri-rocket-2-line' },
  { name: 'Client Success', count: 18, icon: 'ri-user-heart-line' },
];

export const benefits = [
  { icon: 'ri-money-dollar-circle-line', title: 'Competitive Salary', desc: 'Top-tier compensation with annual performance bonuses and equity options for senior roles.' },
  { icon: 'ri-time-line', title: 'Flexible Hours', desc: 'Core hours 11am-5pm with flexible start/end. Remote-friendly with hybrid options.' },
  { icon: 'ri-heart-pulse-line', title: 'Health Coverage', desc: 'Comprehensive health insurance for you and your family. Mental health support included.' },
  { icon: 'ri-graduation-cap-line', title: 'Learning Budget', desc: '₹50,000 annual learning stipend for courses, conferences, and certifications.' },
  { icon: 'ri-flight-takeoff-line', title: 'Annual Retreat', desc: 'All-expenses-paid team retreat every year. Past destinations: Goa, Bali, Dubai.' },
  { icon: 'ri-computer-line', title: 'Top Equipment', desc: 'Latest MacBook Pro, 4K monitor, and all the tools you need to do your best work.' },
];

export const hiringProcess = [
  { step: '01', title: 'Resume Review', desc: 'Our team reviews your application within 48 hours.' },
  { step: '02', title: 'Phone Screen', desc: '30-min call with HR to discuss fit and expectations.' },
  { step: '03', title: 'Technical Round', desc: 'Live coding or portfolio review with the team.' },
  { step: '04', title: 'Culture Interview', desc: 'Meet 2-3 team members to assess collaboration fit.' },
  { step: '05', title: 'Offer & Onboarding', desc: 'Receive your offer within 72 hours. Start your journey!' },
];

export const clientLogos = [
  { name: 'Tata Group', color: 'bg-white/10' },
  { name: 'Reliance', color: 'bg-white/10' },
  { name: 'HDFC Bank', color: 'bg-white/10' },
  { name: 'Mahindra', color: 'bg-white/10' },
  { name: 'Adani', color: 'bg-white/10' },
  { name: 'LIC', color: 'bg-white/10' },
  { name: 'Bajaj', color: 'bg-white/10' },
  { name: 'Cipla', color: 'bg-white/10' },
  { name: 'Zomato', color: 'bg-white/10' },
  { name: 'Nykaa', color: 'bg-white/10' },
];

export const testimonials = [
  {
    name: 'Vikram Singh',
    role: 'CTO, MedLife Healthcare',
    quote: 'DigiIndia transformed our patient management system. The platform now handles 50,000+ patients daily with zero downtime. Their team understood healthcare compliance deeply.',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=Professional%20Indian%20male%20CTO%20headshot%2C%20confident%20expression%2C%20navy%20suit%2C%20clean%20white%20studio%20background%2C%20warm%20natural%20lighting%2C%20high%20quality%20corporate%20portrait%20photography&width=200&height=200&seq=testimonial-vikram&orientation=squarish',
  },
  {
    name: 'Priya Agarwal',
    role: 'VP Operations, Luxe Hotels Group',
    quote: 'The property management system they built handles 200+ hotels seamlessly. Revenue increased 35% in year one. Best technology partner we have worked with in 15 years.',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=Professional%20Indian%20female%20executive%20headshot%2C%20warm%20smile%2C%20cream%20blazer%2C%20clean%20white%20studio%20background%2C%20natural%20lighting%2C%20high%20quality%20corporate%20portrait%20photography&width=200&height=200&seq=testimonial-priya&orientation=squarish',
  },
  {
    name: 'Rajesh Khanna',
    role: 'MD, Apex Manufacturing Ltd.',
    quote: 'Their ERP solution replaced our 20-year-old system. Production efficiency improved by 40%. Real-time inventory tracking across 5 factories. Exceptional engineering quality.',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=Professional%20Indian%20male%20managing%20director%20headshot%2C%20distinguished%20grey%20hair%2C%20charcoal%20suit%2C%20clean%20white%20studio%20background%2C%20soft%20lighting%2C%20high%20quality%20corporate%20portrait%20photography&width=200&height=200&seq=testimonial-rajesh&orientation=squarish',
  },
];

export const awardsAndCerts = [
  { icon: 'ri-medal-line', title: 'ISO 27001 Certified', desc: 'Information Security Management' },
  { icon: 'ri-shield-star-line', title: 'GDPR Compliant', desc: 'Data Protection & Privacy Ready' },
  { icon: 'ri-award-line', title: 'NASSCOM Member', desc: 'Top 50 IT Services Company' },
  { icon: 'ri-building-line', title: 'CMMI Level 3', desc: 'Process Maturity Excellence' },
  { icon: 'ri-hand-heart-line', title: '98% Client Retention', desc: 'Trusted by 500+ businesses' },
  { icon: 'ri-global-line', title: '12 Countries', desc: 'Global Delivery Footprint' },
];